import { DataBadge } from 'components/common';
import type { Invoice } from '@billing/validation/invoice';
import { MRT_ColumnDef } from 'mantine-react-table';

export const InvoiceColumns = () => {
  const columns: MRT_ColumnDef<Invoice>[] = [
    {
      accessorKey: 'file',
      header: 'File Name',
      Cell: ({ cell }) => {
        return <DataBadge>{cell.getValue()}</DataBadge>;
      },
    },
    {
      accessorKey: 'recipient',
      header: 'Recipient',
      accessorFn(row) {
        return row.recipient;
      },
    },
  ];
  return columns;
};
